var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "template",
        { slot: "header" },
        [
          _c("el-alert", {
            attrs: {
              type: "success",
              closable: false,
              title:
                "这个页面展示的是全部数据的存储结构，包括系统区域和存储区域，涵盖所有用户，也就是整个 D2Admin 的数据存储结构"
            }
          })
        ],
        1
      ),
      _c("d2-highlight", { attrs: { code: _vm.dbData } }),
      _c(
        "el-button",
        {
          attrs: { slot: "footer", type: "primary" },
          on: { click: _vm.load },
          slot: "footer"
        },
        [_vm._v(" 重新获取本地数据 ")]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }